import { black, white } from './color-constants';
import { contrast } from './common';
import { neutralFillToggleRest } from './neutral-fill-toggle';
/**
 * Function to derive neutralForegroundToggle from an input background and target contrast ratio
 */
const neutralForegroundToggleAlgorithm = (backgroundColor, targetContrast) => {
    return contrast(white, backgroundColor) >= targetContrast ? white : black;
};
/**
 * Factory to create a neutral-foreground-toggle function that operates on a target contrast ratio
 */
function neutralForegroundToggleFactory(targetContrast) {
    function neutralForegroundToggleInternal(arg) {
        return typeof arg === 'function'
            ? (designSystem) => {
                return neutralForegroundToggleAlgorithm(arg(designSystem), targetContrast);
            }
            : neutralForegroundToggleAlgorithm(neutralFillToggleRest(arg), targetContrast);
    }
    return neutralForegroundToggleInternal;
}
/**
 * @internal
 * Toggle text for normal sized text, less than 18pt normal weight
 */
export const neutralForegroundToggle = neutralForegroundToggleFactory(4.5);
/**
 * @internal
 * Toggle text for large sized text, greater than 18pt or 16pt and bold
 */
export const neutralForegroundToggleLarge = neutralForegroundToggleFactory(3);
